export default {
  'coupon.title': 'คูปอง',
  'coupon.content': 'รายละเอียดคูปอง',
  'coupon.record': 'บันทึกคูปอง',
  'coupon.discount': 'คูปองส่วนลด',
  'coupon.product': 'คูปองสินค้า',
  'coupon.balance': 'คูปองคงเหลือ',
  'coupon.select_redeem_number': 'เลือกจำนวนคูปองที่ต้องการใช้',
  'coupon.error.redeem_fail': 'ไม่สามารถใช้คูปอง"',
  'coupon.error.redeem_fail.not_shop':
    'ไม่สามารถใช้คูปอง คูปองนี้ใช้ได้เฉพาะกับร้านค้าที่กำหนดเท่านั้น',
  'coupon.error.redeem_fail.not_shop_group':
    'ไม่สามารถใช้คูปอง ใช้ได้เฉพาะกับกลุ่มร้านค้าที่กำหนดเท่านั้น',
  'coupon.error.redeem_fail.shop_not_found': 'ไม่สามารถใช้คูปอง ไม่พบข้อมูลร้านค้า',
  'coupon.error.redeem_fail.store_not_found': 'ไม่สามารถใช้คูปอง ไม่พบข้อมูลสาขา/ร้านค้า',
  'coupon.error.redeem_fail.coupon_invalid': 'ไม่สามารถใช้คูปองได้ คูปองนี้ไม่สามารถใช้งานได้',
  'coupon.error.redeem_fail.remaining_not_enough': 'ยอดคงเหลือไม่เพียงพอ',
  'coupon.applicable_store': 'ร้านค้าที่สามารถใช้คูปองได้',
  'coupon.use_period': 'ระยะเวลาการใช้งาน',
  'coupon.quantity_held': 'จำนวนคูปองที่มีอยู่',
  'coupon.transfer': 'โอนคูปอง',
  'coupon.not_enabled': 'คูปองนี้ยังไม่เปิดใช้งาน',
  'coupon.period_is': 'ระยะเวลาการใช้คูปองคือ',
  'coupon.barcode': 'บาร์โค้ด',
  'coupon.guide': 'คำแนะนำ',
  'coupon.choose_redeem_quantity': 'โปรดเลือกจำนวนคูปองที่ต้องการใช้',
  'coupon.empty': 'ขณะนี้ยังไม่มีคูปอง',
  'coupon.empty.product': 'ไม่มีคูปองสินค้าในขณะนี้',
  'coupon.empty.ticket': 'ไม่มีคูปองในขณะนี้',
  'coupon.empty.balance': 'ไม่มีคูปองคงเหลือในขณะนี้',
  'coupon.welcome': 'ยินดีต้อนรับสู่กิจกรรมแจกคูปอง',
  'coupon.redeemable': 'สามารถแลกได้',
  'coupon.not_start': 'ยังไม่สามารถใช้งานได้',
  'coupon.redeem_immediately': 'แลกทันที',
  'coupon.notification_time': 'เวลาการแจ้งเตือน',
  'coupon.receive_time': 'เวลารับคูปอง',
  'coupon.giver': 'ผู้มอบ',
  'coupon.copy_success': 'คัดลอกบาร์โค้ดสำเร็จ',
  'coupon.redeem_coupon': 'แลกใช้คูปอง',
  'coupon.redeem_store': 'ร้านค้าที่แลกใช้คูปอง',
  'coupon.not_start_yet': 'คูปองนี้ยังไม่เปิดใช้บริการ',
  'coupon.redeem_count': 'จำนวนคูปองที่ถูกใช้แล้ว',
  'coupon.redeemed': 'คูปองที่ถูกใช้แล้ว',
  'coupon.expired': 'คูปองที่หมดอายุ',
  'coupon.voided': 'คูปองที่ถูกยกเลิก',
  'coupon.receive': 'รับคูปองของขวัญ',
  'coupon.balance_amount': 'คูปองคงเหลือ',
  'coupon.using': 'คูปองที่กำลังใช้งาน',
  'coupon.not_used': 'คูปองที่ยังไม่ถูกใช้งาน',
  'coupon.use_record': 'ประวัติการใช้คูปอง',
  'coupon.use_amount': 'จำนวนที่ใช้',
  'coupon.use_time': 'เวลาที่ใช้',
  'coupon.use_store': 'ร้านค้าที่ใช้',
  'coupon.ticket_serial_number': 'หมายเลขซีเรียลของคูปอง',
  'coupon.remaining_amount': 'ยอดคงเหลือที่สามารถใช้ได้',
  'coupon.enter_use_amount': 'กรุณาระบุจำนวนที่ใช้',
  'coupon.cancel_transfer_success': 'ยกเลิกการโอนคูปองสำเร็จ',
  'coupon.cancel_transfer_fail': 'ยกเลิกการโอนคูปองล้มเหลว',
  'coupon.obtain_time': 'เวลาที่ได้รับ',
  'coupon.gift': 'ของขวัญ',
  'coupon.issuer': 'ผู้ส่งคูปอง',
  'coupon.redeem_time': 'เวลาที่ใช้คูปอง',
  'coupon.redeem_status': 'สถานะการใช้คูปอง',
  'coupon.redeem_no': 'หมายเลขการใช้คูปอง',
  'coupon.disable_time': 'วันหมดอายุ',
  'coupon.account_status': 'สถานะการใช้งานบัญชี',
  'coupon.overdue_time': 'วันหมดอายุ',
  'coupon.cancel_transfer': 'ยกเลิกการโอนคูปอง',
  'coupon.count_number': 'จำนวนทั้งหมด',
  'coupon.used_amount': 'จำนวนที่ใช้ไปแล้ว',
  'coupon.recent_use_time': 'ใช้ล่าสุดเมื่อ',
  'coupon.recent_use_store': 'ร้านค้าที่ใช้ล่าสุด',
  'coupon.redeem_code': 'กรุณาใส่รหัสการใช้คูปอง',
  'coupon.waiting': 'กำลังดำเนินการ กรุณารอสักครู่...',
  'coupon.byurl.collect_message': 'ยืนยันการรับ {name} หรือไม่?',
  'coupon.byurl.confirm': 'ยืนยัน',
  'coupon.byurl.cancel': 'ยกเลิก',
  'coupon.byurl.OK': 'รับทราบ',
  'coupon.byurl.already_message': 'คุณได้รับคูปองแล้ว!',
} as Record<string, string>;
